export default "__VITE_ASSET__BnFJ6gI8__"